import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M2.667 11.111v2.222h2.222l6.553-6.553L9.22 4.558l-6.553 6.553zm10.493-6.05c.231-.23.231-.604 0-.835L11.774 2.84c-.232-.231-.605-.231-.836 0L9.854 3.924l2.222 2.222 1.084-1.084z"
	})
});
export default SvgIconEdit;
